var render = function render(){var _vm=this,_c=_vm._self._c;return (typeof _vm.value === 'number')?_c('span',[_vm._v(" "+_vm._s(new Intl.NumberFormat(_vm.getLocale, _vm.getOptions).format(_vm.value))+" ")]):_c('span',[_vm._v("--")])
}
var staticRenderFns = []

export { render, staticRenderFns }